var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJpeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000181806255547654564670000012578761806415059120_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "JPEG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440.1 141.4v308.9c0 34.1-27.6 61.7-61.7 61.7h-244.8c-34.1 0-61.7-27.6-61.7-61.7v-388.6c0-34.1 27.6-61.7 61.7-61.7h165.1z",
    fill: "#f15642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.1 141.4h-115.9c-14.1 0-25.5-11.4-25.5-25.5v-115.9z",
    fill: "#ff9587"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m133.1 339.6c10.9 0 16.8-4.4 16.8-18.7v-85.3h14.6v85.3c0 21.5-10.9 33.1-31.5 33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.4 268.4c0 21.3-11.3 33.1-31.2 33.1h-12.2v35.7h-14.6v-101.6h26.8c19.9 0 31.2 12.1 31.2 32.8zm-14.9 0c0-12.5-5.4-18.9-16.4-18.9h-12v38h12c11 0 16.4-6 16.4-19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.1 323.4v13.8h-51.2v-101.6h49.7v13.8h-35v29.4h32.3v13.5h-32.3v31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.9 307v-41.3c0-20.6 11.3-31.6 29.7-31.6 18 0 28.9 10.9 29.6 30.9h-14.5c-.6-11.7-5.8-16.8-15.1-16.8s-14.8 5.4-14.8 17.7v41.1c0 12.3 5.8 17.7 15.2 17.7 9.7 0 15.5-5.4 15.5-17v-12.7h-16.1v-13.1h30.4v25.8c-.3 19.9-11.8 31-30 31s-29.9-11.1-29.9-31.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpeg);
export default __webpack_public_path__ + "static/media/jpeg.c0ff3426902503faa600aa97a426ab58.svg";
export { ForwardRef as ReactComponent };